import { Routes, Route } from "react-router-dom";
import DashboardLayout from "../components/layout/DashboardLayout";
import Settings from "./dashboard/Settings";
import Menu from "./dashboard/Menu";
import Feedback from "./dashboard/Feedback";
import Pricing from "./dashboard/Pricing";
import Hook from "./dashboard/Hook";
import OrderConfirmation from "./dashboard/OrderConfirmation";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";


export default function Dashboard() {
    const navigate = useNavigate()
    const [user, setUser] = useState({
        id: '',
        fullName: '',
        email: '',
        tokens: 0,
        billing: []
    })

    useEffect(() => {
        async function fetchUser() {
            try {
            const response = await API.get("/me");
            setUser({
                id: response.data._id,
                fullName: response.data.fullName,
                email: response.data.email,
                tokens: response.data.tokens,
                billing: response.data.billing || []
            })
            } catch (err) {
            if (err.response && err.response.status === 401) {
                navigate("/login");
            } else {
                console.error(err);
            }
            }
        }

        fetchUser();
        }, [navigate]);

return (
    <DashboardLayout user={user}>
        <Routes>
            <Route path="/" element={<Menu />} />
            <Route path="feedback" element={<Feedback user={user}/>} />
            <Route path="settings" element={<Settings user={user} />} />
            <Route path="pricing" element={<Pricing user={user} />} />
            <Route path="hook" element={<Hook user={user} />} />
            <Route path="order-confirmation" element={<OrderConfirmation />} />
        </Routes>
    </DashboardLayout>
);
}
